import { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Page from '../components/Page';
import { adminApi } from 'src/utils/adminApi';

export default function ClutchPermissions() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi
      .listPermissions()
      .then((result) => setRows(result.data?.items || []))
      .catch((err) => setError(err.message));
  }, []);

  return (
    <Page title={`Permissions | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="lg">
        <Box sx={{ py: 3 }}>
          <Typography variant="h4" sx={{ color: '#F3F4F6', mb: 3 }}>
            Permissions
          </Typography>
          {error && <Typography sx={{ color: '#F87171', mb: 2 }}>{error}</Typography>}
          <Card sx={{ bgcolor: '#151921', border: '1px solid #232935' }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {['Name', 'Slug'].map((head) => (
                      <TableCell key={head}>{head}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ color: '#F3F4F6' }}>{row.name}</TableCell>
                      <TableCell>{row.slug}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
